import React from 'react'
import Qoute from '../components/Qoute'

export default function ContactUs() {
  return (
    <div className=''>
      <Qoute />
    </div>
  )
}
